<span *ngIf="('MENU_HISTORY.HELP_LINK' | translate).length > 0" >
  <a class="alert-button " href="{{link}}" target="_blank">
    {{'MENU_HISTORY.HELP_LINK' | translate}}
  </a>
</span>
